module.exports = __webpack_public_path__ + "static/img/kogatahachi_rui.670ed08.jpg";